import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import GameIcon from 'components/GameIcon';
import './ContinuePlaying.css';

class ContinuePlaying extends Component {
  render() {
    const { games } = this.props;

    return (
      <div className="continue-playing-wrapper">
        <div className="title">Continue Playing</div>
        <div className="content">
          {games.slice(0, 3).map(game => (
            <div className="game-card">
              <div className="game-icon">
                <Link className="game-play" to={`/game/${game.slug}`}>
                  <GameIcon
                    game={game}
                    badge={game.badge}
                    alt={game.displayName}
                  />
                </Link>
              </div>
              <div className="sub-title">{game.displayName}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ContinuePlaying;
